import { TFunction } from 'i18next';
import * as yup from 'yup';

export const validationSchema = (t: TFunction) =>
  yup.object({
    restaurantId: yup.string(),
    uberEatsLink: yup
      .string()
      .trim()
      .ensure()
      .when({
        is: (val: any) => val && val.length > 0,
        then: (val) =>
          val.matches(
            /https?:\/\/(www\.)?ubereats\.com\/([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)/,
            'uberEatsLink must be a valid URL.'
          )
      })
      .nullable()
      .optional(),
    deliverooLink: yup
      .string()
      .trim()
      .ensure()
      .when({
        is: (val: any) => val && val.length > 0,
        then: (val) =>
          val.matches(
            /https?:\/\/(www\.)?deliveroo\.[a-zA-Z0-9()]{1,6}\/([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)/,
            'deliverooLink must be a valid URL'
          )
      })
      .nullable()
      .optional(),

    justEatLink: yup
      .string()
      .trim()
      .ensure()
      .when({
        is: (val: any) => val && val.length > 0,
        then: (val) =>
          val.matches(
            /https?:\/\/(www\.)?(just-eat|takeaway)\.[a-zA-Z0-9()]{1,6}\/([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)/,
            'justEatLink must be a valid URL'
          )
      })
      .nullable()
      .optional(),
    customDeliveryLink: yup.string().trim().url().nullable().optional(),

    alcohol: yup
      .boolean()
      .typeError(t('proposeRestaurant.alcoholStatus')),

    autocompleteTag: yup.string(),
    tagIds: yup.array(yup.string()).min(1, t('proposeRestaurant.atLeastOneSpecialtyError')),

    instagramLink: yup
      .string()
      .nullable()
      .matches(
        /^(https?:\/\/)?(www\.)?instagram\.com\/[a-zA-Z0-9._-]+\/?$/,
        {
          message: t('proposeRestaurant.invalidLink'),
          excludeEmptyString: true,
        }
      ),
    facebookLink: yup
      .string()
      .nullable()
      .matches(
        /^(https?:\/\/)?(www\.)?facebook\.com\/[a-zA-Z0-9._-]+\/?$/,
        {
          message: t('proposeRestaurant.invalidLink'),
          excludeEmptyString: true,
        }
      ),
    phoneNumberOwner: yup
      .string()
      .matches(/^(\+33|0)[\s-]?[67][\s-]?(\d[\s-]?){8}$/, {
        message: t('proposeRestaurant.phoneNumberFormatStatus'),
        excludeEmptyString: true
      }),
  });

export type UpdateRestaurantSchemaType = yup.InferType<ReturnType<typeof validationSchema>>;
